// Fixed across schools: a group's colour follows its name, never its rank or brand.
export const SCHOOL_GROUP_PASTELS = Object.freeze({
  '1st years': { surface: '#E8F4FF', border: '#BFDCF4', ink: '#1F689A', track: '#CFE7F8' },
  '2nd years': { surface: '#F0E9FF', border: '#DCCBFA', ink: '#7651A8', track: '#E1D5F5' },
  '3rd years': { surface: '#E6F8EC', border: '#C8EBD4', ink: '#26754A', track: '#D2EFDD' },
  '4th years': { surface: '#FFF0E3', border: '#F5D8C1', ink: '#9B5228', track: '#F8DFC9' },
  '5th years': { surface: '#FFF7D8', border: '#F0E3A8', ink: '#8B6B1F', track: '#F5E9BD' },
  '6th years': { surface: '#FFEAF2', border: '#F2CDE0', ink: '#A94D78', track: '#F7D9E7' },
  'staff room': { surface: '#E4F7F5', border: '#C4E8E2', ink: '#2C716A', track: '#D0EEEA' },
});

const OTHER_SCHOOL_GROUP_PASTEL = { surface: '#F0F3F8', border: '#D8E2EC', ink: '#52677F', track: '#DEE6EF' };
const UNASSIGNED_MEMBER_INKS = Object.values(SCHOOL_GROUP_PASTELS).map((pastel) => pastel.ink);

export const schoolGroupPastel = (name) => (
  SCHOOL_GROUP_PASTELS[String(name || '').trim().replace(/\s+/g, ' ').toLowerCase()]
  || OTHER_SCHOOL_GROUP_PASTEL
);

export const schoolMemberProgressColor = (groupName, rankIndex) => (
  groupName
    ? schoolGroupPastel(groupName).ink
    : UNASSIGNED_MEMBER_INKS[Math.max(0, Number(rankIndex) || 0) % UNASSIGNED_MEMBER_INKS.length]
);

export const schoolMemberYearLabel = (name) => String(name || '').replace(/^([1-6](?:st|nd|rd|th)) Years$/i, '$1 Year');
